
































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import productHome from "../modules/productHome.vue";
import accountStatus from "../modules/trainAccountStatus.vue";
import { Calendar, Field, Tag, ActionSheet, NoticeBar } from "vant";
import dataShare from "../dataShare";
import * as _ from "lodash";
import moment from "moment";
import { YesOrNo } from "@/model/Base";
import huilianyiService from "@/service/huilianyiService";
@Component({
  components: {
    [Field.name]: Field,
    [Tag.name]: Tag,
    [Calendar.name]: Calendar,
    [ActionSheet.name]: ActionSheet,
    [NoticeBar.name]: NoticeBar,
    "product-home": productHome,
    "account-status": accountStatus,
  },
})
export default class Train extends Vue {
  accountModel = {
    OuterUserAct: "",
  };
  notifyText =
    "自2021年10月1日起，在力程商旅预订火车票将需要关联12306账号，未完成关联的预订人将无法使用铁路官方网站的相关服务（出票、改签、退票等），为避免您的出行受到影响，请务必在此日期前完成相关操作。";
  //data
  dataShare = dataShare;
  datePickerVisible = false;
  isShowNotify = false;
  query:any = {
    pageIndex: 1,
    DepartDate: (this as any).$moment().format("YYYY-MM-DD"),
    DepartCity: "SHH",
    DepartCityName: this.$root.$t("mall_train_train_shanghai") as string,
    ArriveCity: "BJP",
    ArriveCityName: this.$root.$t("mall_train_train_beijing") as string,
    BookingType: 1529,
    ServiceType: "TrainService",
    ApplyArea: 1126,
    FeatureCodes: "",
    Consumers: "",
  };
  changeCityFlag = false;

  get trainCycle() {
    return moment()
      .add(14, "d")
      .toDate();
  }

  get isSearch() {
    let startTime = moment()
      .hours(5)
      .minutes(30)
      .seconds(0)
      .format("YYYY-MM-DD HH:mm:ss");
    let endTime = moment()
      .hours(24)
      .minutes(30)
      .seconds(0)
      .format("YYYY-MM-DD HH:mm:ss");
    var hours = moment().get("hours");
    var day = new Date().getDay();
    if (hours == 0 && day != 2) {
      startTime = moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .format("YYYY-MM-DD HH:mm:ss");
      endTime = moment()
        .hours(0)
        .minutes(30)
        .seconds(0)
        .format("YYYY-MM-DD HH:mm:ss");
    }

    if (day == 2) {
      endTime = moment()
        .hours(23)
        .minutes(0)
        .seconds(0)
        .format("YYYY-MM-DD HH:mm:ss");
    }

    if (moment(moment().format("YYYY-MM-DD HH:mm:ss")).isBetween(startTime, endTime, null, "[]")) {
      return true;
    } else {
      return false;
    }
  }

  get City() {
    return this.dataShare.City;
  }
  set City(value: any) {
    this.dataShare.City = value;
  }
  get ShowApproval(){
      return this.oldApprovalList?.some((item:any)=>item.travelTrainsList);
    }

  mounted() {
    this.City = null;
    this.dataShare.consumers = [];
  }

  //activated
  activated() {
    // this.Consumers = dataShare.consumers;
    if (this.selectCode && this.City && this.City.value) {
      let City = this.City;
      if (this.selectCode == "DepartCity") {
        // this.departCity = this.City;
        this.query.DepartCityName = City.label;
        this.query.DepartCity = City.value;
      } else if (this.selectCode == "ArriveCity") {
        // this.arriveCity = this.City;
        this.query.ArriveCityName = City.label;
        this.query.ArriveCity = City.value;
      }
    }
    this.searchapproval();
  }

  //methods
  formatDate(value: Date, format: string = this.$root.$t("mall_train_train_yueri") as string) {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }

  handleSelect(time: Date) {
    this.datePickerVisible = false;
    this.query.DepartDate = time;
  }

  Consumers = [];
  //选择乘客
  gotoAddPassengers() {
    dataShare.consumers = this.Consumers;
    this.$router.push("addPassengers?max=5");
  }
  //取消选择旅客
  closeBar(consumer: object) {
    this.Consumers = _.difference(this.Consumers, [consumer]) as any;
  }
  OneSelf = null;
  showConsumers() {
    let Flag = true;
      if (this.isApproval) {
        return (Flag = false);
      } else  {
        if(this.OneSelf == YesOrNo.Yes){
          let consumers: any = [
          {
            RoleID: this.profile.UserID,
            RoleName: this.profile.UserName,
          },
          ];
          dataShare.consumers = consumers;
          return (Flag = false);
        }
      }
      return Flag;
  }
  OneSelfs(value: any) {
    this.OneSelf = value;
  }
  @Watch("dataShare.consumers")
  handelConsumers(value: any) {
    this.Consumers = dataShare.consumers;
  }

  selectCode = "";
  selectCity(cityType: string) {
    this.City = null;
    this.selectCode = cityType;
    this.$router.push({
      path: "/selectCity",
      query: {
        ServiceType: this.query.ServiceType,
        ApplyArea: this.query.ApplyArea + "",
      },
    });
  }

  changeCity() {
    this.changeCityFlag = !this.changeCityFlag;
    const newArriveCity = this.query.ArriveCity;
    const newArriveCityName = this.query.ArriveCityName;
    this.query.ArriveCity = this.query.DepartCity;
    this.query.ArriveCityName = this.query.DepartCityName;
    this.query.DepartCity = newArriveCity;
    this.query.DepartCityName = newArriveCityName;
  }

  search() {
     if(this.isApproval){
        // 判断起飞到达是否有一个在审批单航程中
        if(this.CityCodeList.length > 0 && !this.CityCodeList.includes(this.query.DepartCity) && !this.CityCodeList.includes(this.query.ArriveCity)){
          return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_shenpidanhangcheng") as string);
        }
        if(!this.isDateInSections(this.query.DepartDate)){
          return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_shenpidanchufariqi") as string);
        }
      }
    this.query.Consumers = JSON.stringify(
      this.Consumers.map((item: any) => ({ ConsumerID: item.RoleID, ConsumerName: item.RoleName, SuperiorName: item.SuperiorName || '', SuperiorType: item.SuperiorType || '' }))
    );
    this.query.DepartDate = this.formatDate(this.query.DepartDate, "YYYY-MM-DD");
    if(this.isApproval) this.query.approvalCode = this.approvalCode;
    if (this.Consumers.length == 0) {
      return this.$root.$toast.fail(this.$root.$t("mall_train_train_qingxuanzelvke") as string);
    }
    this.$router.push({ path: "train/list", query: this.query as any });
  }
  checkAuditTime(beginTime: any, endTime: any) {
    var nowDate = new Date();
    var beginDate = new Date(nowDate);
    var endDate = new Date(nowDate);

    var beginIndex = beginTime.lastIndexOf("\:");
    var beginHour = beginTime.substring(0, beginIndex);
    var beginMinue = beginTime.substring(beginIndex + 1, beginTime.length);
    beginDate.setHours(beginHour, beginMinue, 0, 0);

    var endIndex = endTime.lastIndexOf("\:");
    var endHour = endTime.substring(0, endIndex);
    var endMinue = endTime.substring(endIndex + 1, endTime.length);
    endDate.setHours(endHour, endMinue, 0, 0);
    return nowDate.getTime() - beginDate.getTime() >= 0 && nowDate.getTime() <= endDate.getTime();
  }
  approvalList:any = [];
  oldApprovalList:any = [];
  searchapproval() {
     let __self = this;
     huilianyiService.searchapprovals().then((res:any) => {
       __self.approvalList = res.result || [];
       __self.approvalList = __self.approvalList.map((item:any) => {
          const guestNames = item.participantList.map((item:any) => item.name).join(',');
          return {...item, guestNames, isCheck: false};
        });
        __self.oldApprovalList = JSON.parse(JSON.stringify(__self.approvalList));
        __self.approvalList = __self.oldApprovalList.filter((i:any) => i.status == __self.activeStatus);
        __self.initBooking();
     });
  }
  initBooking(){
        let __self = this;
        const approvalCode = __self.$route.query.approvalCode;
        if(approvalCode){
            const approvalInfo = __self.approvalList.find((item:any) => item.approvalCode === approvalCode);
            if(approvalInfo){
            // 其余项禁用
            __self.approvalList.forEach((item:any) => {
                if(item.approvalCode === approvalCode) item.isCheck = true;
            });      
            __self.oldApprovalList = JSON.parse(JSON.stringify(__self.approvalList));
            __self.echoSearchInfo(approvalInfo);
            };  
        }
    }
    CityCodeList:any[]=[];
    DepartDateSection:any[]=[];
    isApproval:boolean = false;
    approvalCode:string = '';
   echoSearchInfo(data: any){
        let __self = this;
        const travelTrainsList = data.travelTrainsList;
        const trainInfo = travelTrainsList[0]
        travelTrainsList.forEach((item:any) => {
          __self.CityCodeList.push(item.fromCityCode,item.toCityCode);
          __self.DepartDateSection.push({
            startDate:item.takeOffBeginTime ? moment(item.takeOffBeginTime).valueOf() : 'ALL', 
            endDate:item.takeOffEndTime ? moment(item.takeOffEndTime).valueOf() : 'ALL'
          })
        });
        // 去重处理
        __self.CityCodeList = _.uniq(__self.CityCodeList);
        __self.approvalCode = data.approvalCode;
        __self.Consumers = data.participantList.map((item:any)=>{
          return { RoleID: item.ConsumerID, RoleName: item.name }
        });
        __self.isApproval = true;
      if (trainInfo.fromCity != "" && trainInfo.fromCity != undefined) {
        __self.query.DepartCity =  trainInfo.fromCityCode;
        __self.query.DepartCityName = trainInfo.fromCity;
      }
      if (trainInfo.toCity != "" && trainInfo.toCity != undefined) {
        __self.query.ArriveCity =  trainInfo.toCityCode;
        __self.query.ArriveCityName = trainInfo.toCity;
      }
      if (trainInfo.takeOffBeginTime || trainInfo.takeOffBeginTime != "") {
        __self.query.DepartDate = trainInfo.takeOffBeginTime;
      }
    }
  isDateInSections(tiem:string) {
    const timestamp = moment(tiem).valueOf();
    const sections = this.DepartDateSection ;
    return sections.some((section:any) => {
      // 处理可能的无效数据
      if (!section || !section.startDate || !section.endDate) {
        return false;
      }

      // 如果 startDate 和 endDate 都是 'ALL'，则直接满足条件
      if (section.startDate === 'ALL' && section.endDate === 'ALL') {
        return true;
      }

      // 如果只有 startDate 是 'ALL'，则只需要验证 endDate
      if (section.startDate === 'ALL') {
        return timestamp <= Number(section.endDate);
      }

      // 如果只有 endDate 是 'ALL'，则只需要验证 startDate
      if (section.endDate === 'ALL') {
        return timestamp >= Number(section.startDate);
      }

      // 都不是 'ALL' 的情况下，进行常规范围检查
      const start = Number(section.startDate);
      const end = Number(section.endDate);
      const checkTime = Number(timestamp);

      // 检查是否为有效数字
      if (isNaN(start) || isNaN(end) || isNaN(checkTime)) {
        return false;
      }

      return checkTime >= start && checkTime <= end;
    });
  }
  activeStatus:number = 2;
  tabChange(status:number){
    this.approvalList = this.oldApprovalList.filter((i:any) => i.status == status);
  }
}
